import { unitMapping } from 'lib/style';

import { IconColor, useIconColor } from './useIconColor';

type Props = {
  active?: boolean;
  size?: keyof typeof unitMapping;
  color?: IconColor;
};

export const Scores = ({ active, size = 3, color }: Props) => {
  const { fill, svgNode } = useIconColor(color);
  const activeFill = active ? fill : 'none';
  const inactiveFill = active ? 'none' : fill;
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 36h120v96H20V36zm56 12h8v16h-8zm0 28h8v16h-8zm0 28h8v16h-8zM45 89.47l-2.412 2.412v4.47h20.588V104H34V88.823l5.941-5.94 12.235-2.765 2.412-2.412v-4.118l-1.94-1.94h-8.766l-4.058 4.058L34 69.882 39.882 64h16.824l6.47 6.47v10.295l-5.94 5.94L45 89.472zM120.059 64l7.059 7.059V96.94l-7.059 7.06h-16L97 96.941V71.06l7.059-7.06h16zm-4.118 32.353l2.588-2.588v-19.53l-2.588-2.588h-7.765l-2.588 2.588v19.53l2.588 2.588h7.765z"
        fill={activeFill}
      />
      <path d="M14 30h132v108H14V30z" stroke={fill} strokeWidth="12" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76 48h8v16h-8zm0 28h8v16h-8zm0 28h8v16h-8zM45 89.47l-2.412 2.412v4.47h20.588V104H34V88.823l5.941-5.94 12.235-2.765 2.412-2.412v-4.118l-1.94-1.94h-8.766l-4.058 4.058L34 69.882 39.882 64h16.824l6.47 6.47v10.295l-5.94 5.94L45 89.472zM120.059 64l7.059 7.059V96.94l-7.059 7.06h-16L97 96.941V71.06l7.059-7.06h16zm-4.118 32.353l2.588-2.588v-19.53l-2.588-2.588h-7.765l-2.588 2.588v19.53l2.588 2.588h7.765z"
        fill={inactiveFill}
      />
      {svgNode}
    </svg>
  );
};
